import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap, switchMapTo } from "rxjs/operators";
import { utilTick } from "../../../utils/utilTick";
import { utilTime } from "../../../utils/utilTime";
import { TypeActionApp } from "../../app/actionApp";
import { actionContractInfoRequest } from "../../market/actionContractInfo";
export var epicTimeContractInfo = function (action$, state$) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMapTo(utilTick.second$), switchMap(function () {
        var state = state$.value;
        var actions = [];
        if (state.contractInfo && state.contractInfo.contract) {
            var contracts = state.contractInfo.contract;
            contracts.forEach(function (contract) {
                if (contract.remainingTime) {
                    var timeLeft = utilTime.secondsLeftTill(contract.remainingTime);
                    if (timeLeft <= 0) {
                        actions.push(actionContractInfoRequest());
                    }
                }
            });
        }
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/time/epics/epicTimeContractInfo.ts
// module id = 2432
// module chunks = 3